module.exports = __webpack_public_path__ + "img/orchestre-js.28bc05a5.png";